import gql from 'graphql-tag';

import { getSingleProp } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';
import { BRIEF_DEBUG_DATA_VISIBLE } from 'src/lib/featureFlags';
import { FRAGMENT_RECOMPOSE_REQUEST } from './schema';

const MUTATION = gql`
  mutation RephraseTextsForLpco(
    $projectId: ID!
    $generationTool: GenerationToolEnum!
    $brief: BriefInput!
    $scoringMethod: ScoringMethodInput
    $text: String!
    $recomposeMode: String
    $keywords: String
    $language: String!
    $languageTargetFormality: LanguageTargetFormalityEnum
    $numberOfVariations: Int!
    $tone: String
    $agePreset: AgePresetEnum
    $tovId: ID
    $enterpriseModelId: ID
    $debugAcPrompt: String
    $landingPageAssetId: ID
    $maxChars: Int
  ) {
    rephraseTextsForLpco(
      projectId: $projectId
      generationTool: $generationTool
      brief: $brief
      scoringMethod: $scoringMethod
      text: $text
      recomposeMode: $recomposeMode
      keywords: $keywords
      language: $language
      languageTargetFormality: $languageTargetFormality
      numberOfVariations: $numberOfVariations
      tone: $tone
      agePreset: $agePreset
      tovId: $tovId
      enterpriseModelId: $enterpriseModelId
      debugAcPrompt: $debugAcPrompt
      landingPageAssetId: $landingPageAssetId
      maxChars: $maxChars
    ) {
      ...RecomposeRequest
    }
  }
  ${FRAGMENT_RECOMPOSE_REQUEST}
`;

const prepareContext = (params) => {
  if (!BRIEF_DEBUG_DATA_VISIBLE) {
    return null;
  }

  const title = `"document recompose" request [${JSON.stringify(params)}]`;
  return { traceAuthorComplete: true, traceAuthorCompleteTitle: title };
};

export const rephraseTextsForLpco = async ({
  projectId,
  generationTool,
  brief,
  scoringMethod,
  text,
  recomposeMode,
  keywords,
  language,
  numberOfVariations,
  tone,
  agePreset,
  tovId,
  enterpriseModelId,
  debugAcPrompt,
  landingPageAssetId,
  languageTargetFormality,
  maxChars,
}) => {
  const variables = {
    projectId,
    generationTool,
    brief,
    scoringMethod,
    text,
    recomposeMode,
    keywords,
    language,
    numberOfVariations,
    tone,
    agePreset,
    tovId,
    enterpriseModelId,
    debugAcPrompt,
    landingPageAssetId,
    languageTargetFormality,
    maxChars,
  };

  const response = await apolloClient.mutate({
    mutation: MUTATION,
    variables,
    context: prepareContext(variables),
  });
  return getSingleProp(response.data);
};
